var _line, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconSplitScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 32,
    y1: 9.04,
    x2: 32,
    y2: 54.96,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4.79px"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "wasm-icon-stroke",
    x: 42.18,
    y: 16.45,
    width: 13.53,
    height: 30.44,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4.79px"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "wasm-icon-stroke",
    x: 8.29,
    y: 16.45,
    width: 13.53,
    height: 30.44,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4.79px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconSplitScreen);
export default __webpack_public_path__ + "static/media/SDS_icon_SplitScreen.e383666f63196b8d25b815fa13cee940.svg";
export { ForwardRef as ReactComponent };